import { render, staticRenderFns } from "./coopba-topbar.vue?vue&type=template&id=123d2d36&"
import script from "./coopba-topbar.vue?vue&type=script&lang=ts&"
export * from "./coopba-topbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports